import { AbstractEntity, PropertyValuesDictionary, Transaction, UiData } from "plethora-lib" // GENERATED
import {
  DataTypeShapeType,
  DataTypeDirection,
  DataTypeSize,
  DataTypeColor,
} from "../GeneratedClasses/GeneratedDataTypes" // GENERATED
import { GeneratedScreen } from "../GeneratedClasses/GeneratedScreen" // GENERATED

export class Screen extends GeneratedScreen {
  constructor(id: number, propertyValues: PropertyValuesDictionary, uiData: UiData) {
    super(id, propertyValues, uiData)

    gameInstance.SendMessage("GridManager", "CreateScreen", this.id)
  }

  public onDelete(uiData: UiData): void /* GENERATED */ {
    super.onDelete(uiData)
    // YOUR CODE HERE
  }

  public onDestory(): void /* GENERATED */ {
    super.onDestory()
    // YOUR CODE HERE
  }

  public onSetHighlight(highlight: boolean): void /* GENERATED */ {
    super.onSetHighlight(highlight)
    // YOUR CODE HERE
  }

  protected onClick(uiData: UiData): void /* GENERATED */ {
    // YOUR CODE HERE
  }
}
